import { render, staticRenderFns } from "./UtilWarningOutdatedBrowser.vue?vue&type=template&id=f18f7984&"
import script from "./UtilWarningOutdatedBrowser.vue?vue&type=script&lang=js&"
export * from "./UtilWarningOutdatedBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports